/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    [
      'मध्यरात्रि', 'सुबह', 'अपराह्न', 'शाम',
      'रात'
    ],
    ,
  ],
  [
    ['आधी रात', 'सुबह', 'अपराह्न', 'शाम', 'रात'],
    ['मध्यरात्रि', 'सुबह', 'दोपहर', 'शाम', 'रात'],
  ],
  ['00:00', ['04:00', '12:00'], ['12:00', '16:00'], ['16:00', '20:00'], ['20:00', '04:00']]
];
